import { MockServiceGroup, MockServiceGroupState } from './mockServiceGroupTypes';
import { createAction, createReducer } from '@reduxjs/toolkit';
import { Filter } from '../mockServices/mockServiceTypes';
import _ from 'lodash';

const DEFAULT_STATE: MockServiceGroupState = {
  mockServiceGroups: [],
  isLoading: true,
  isSaving: false,
  lastUpdate: 0,
  mockGroupTableMeta: {
    servicesInProgress: [],
  },
  expandedGroupId: null,
  activePage: 1,
  filter: { status: null, shipId: null, location: null, search: null },
};

export const createGroup = createAction<MockServiceGroup>('CREATE_GROUP');
export const deleteGroup = createAction<MockServiceGroup>('DELETE_GROUP');
export const updateGroupList = createAction<MockServiceGroup[]>('UPDATE_GROUP_LIST');
export const expandGroup = createAction<number | null>('EXPAND_GROUP');
export const updateGroupFilter = createAction<Filter>('UPDATE_GROUP_FILTER');
export const updateGroup = createAction<MockServiceGroup>('UPDATE_GROUP');
export const setGroupsIsLoading = createAction<boolean>('SET_GROUPS_IS_LOADING');

export const mockServiceGroupReducer = createReducer(DEFAULT_STATE, builder => {
  builder.addCase(createGroup, (state, action) => {
    const groups = _.cloneDeep(state.mockServiceGroups);
    if (!_.isNil(groups)) {
      state.mockServiceGroups.unshift(action.payload);
    }
  });
  builder.addCase(deleteGroup, (state, action) => {
    const groupList = _.cloneDeep(state.mockServiceGroups);
    state.mockServiceGroups = _.remove(groupList, item => item.id !== action.payload.id);
  });
  builder.addCase(updateGroupList, (state, action) => {
    state.mockServiceGroups = action.payload;
    state.isLoading = false;
  });
  builder.addCase(expandGroup, (state, action) => {
    if (state.expandedGroupId === action.payload) {
      state.expandedGroupId = null;
    } else {
      state.expandedGroupId = action.payload;
    }
  });
  builder.addCase(updateGroupFilter, (state, action) => {
    state.filter = action.payload;
  });
  builder.addCase(updateGroup, (state, action) => {
    const groups = _.cloneDeep(state.mockServiceGroups);
    const index = _.findIndex(groups, item => item.id === action.payload.id);
    if (index !== -1) {
      groups[index] = action.payload;
      state.mockServiceGroups = groups;
    }
  });
  builder.addCase(setGroupsIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });
});
